import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, Dialog } from "../../../components";
import {
  notification,
  PessoaService,
  SegmentoService,
} from "../../../services";
import { responseErros } from "../../../utils";
import { PermisoesHelper } from "../../../helpers";
import AddSegmento from "../addSegmentos/addSegmento.view";

const ListSegmentosView = () => {
  const segmentoService = new SegmentoService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const pessoaService = new PessoaService();
  const [loading, setLoading] = useState(false);
  const [segmentoId, setSegmentoId] = useState(null);
  const [pessoasList, setPessoasList] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [segmentos, setSegmentos] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaSegmentos();
    buscarPessoas();
  }, []);

  const buscaSegmentos = async (query) => {
    const filter = {
      ...query,
    };
    setLoading(true);
    const result = await segmentoService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setSegmentos(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarPessoas = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await pessoaService.getAll(filtros);
    if (!res.isAxiosError) {
      setPessoasList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setSegmentoId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSegmentoId(null);
    setOpenDialog(false);
  };

  const sendServerDatagrid = (props) => {
    buscaSegmentos(props.filtros);
  };

  const handleDeleteSegmento = async (id) => {
    const pessoa = pessoasList.some((item) => item.segmentoId === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir esse segmento de pessoas?`
    );
    if (retornoAlerta.isConfirmed) {
      if (pessoa) {
        notification.alertaGenericos(
          "Não se pode remover segmentos inserido em outros cadastros"
        );
        return;
      }
      setLoading(true);
      const result = await segmentoService.deletar(id);
      if (!result.isAxiosError) {
        buscaSegmentos();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  return (
    <ListLayout
      title="Segmentos"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("segmentos-cadastrar")}
    >
      <DataGrid
        rows={segmentos}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={handleDeleteSegmento}
        visualizarShow={permissoesHelper.temPermisao("segmentos-visualizar")}
        editShow={permissoesHelper.temPermisao("segmentos-editar")}
        deleteShow={permissoesHelper.temPermisao("segmentos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <AddSegmento
          id={segmentoId}
          handleCloseDialog={handleCloseDialog}
          openDialog={openDialog}
          buscaSegmentos={buscaSegmentos}
        />
      </Dialog>
    </ListLayout>
  );
};

export default ListSegmentosView;
